import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import AOS from "aos";
import CountUp from "react-countup";
import ScrollTrigger from "react-scroll-trigger";

// Services & Helpers
import { getLocalStorageData } from "../../services/localStorageService";

// Styles
import "./Home.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";

const Home = () => {
    const navigate = useNavigate();

    // Login Condition Logic
    const userData = getLocalStorageData("user");
    const isLoggedIn = !!userData?.token;

    // Memoized Settings to maintain performance and layout
    const settings = useMemo(() => ({
        homeBanner: {
            autoplay: true,
            autoplaySpeed: 2000,
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        },
        testimonialSlider: {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
            ],
        },
        ourStoriesSlider: {
            dots: false,
            infinite: false,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
            ],
        }
    }), []);

    useEffect(() => {
        AOS.init({ duration: 1000, once: false });
    }, []);

    return (
        <>
            {/* Banner Section */}
            <Slider className="home-banner" {...settings.homeBanner}>
                <div className="banner-img">
                    <img src="assets/imgs/banner_img.png" alt="Banner 1" />

                    <div className="banner-content">
                        <h1 className="font-medium">
                            Start Your Beautiful Journey of Love, <br></br>Trust, and
                            Companionship
                        </h1>
                        <p>
                            Discover meaningful connections with people who share your values
                            and dreams.
                        </p>

                        <div className="d-flex mt-4">
                            {!isLoggedIn ? (
                                <>
                                    {/* Restored exact <a> tags and hrefs from original code */}
                                    <a href="Product" className="btn banner_btn me-3" data-bs-toggle="modal" data-bs-target="#registrationModal">
                                        Register Now
                                    </a>
                                    <a href="Product" className="btn banner_btn" data-bs-toggle="modal" data-bs-target="#loginModal">
                                        Login
                                    </a>
                                </>
                            ) : (
                                <a onClick={() => navigate("/dashboard")} className="btn banner_btn" style={{ cursor: 'pointer' }}>
                                    Go to Dashboard
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </Slider>

            {/* Intro Section - Restored exact AOS timing and wrappers */}
            <section className="h-about-us">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <img
                                className="about-img"
                                src="assets/imgs/intro_img.png"
                                alt="Intro"
                                data-aos="fade-up"
                                data-aos-easing="ease-in-out"
                                data-aos-duration="500"
                            />
                        </div>
                        <div
                            className="col-md-6 about_right-content"
                            data-aos="fade-up"
                            data-aos-easing="ease-in-out"
                            data-aos-duration="700"
                        >
                            <div className="section-heading">
                                <h1 className="headingtxt">Welcome to <br /> <span>Vikas Mandal Mulund</span></h1>
                            </div>
                            <div className="txt-content">
                                <p>
                                    Where timeless traditions meet modern connections. Our Marathi matrimonial platform is a harmonious blend of cultural richness and contemporary matchmaking, dedicated to fostering enduring relationships within the vibrant Marathi community. Explore a world of possibilities as we celebrate the beauty of love, commitment, and shared values.
                                </p>
                            </div>
                            <div className="cont_d_cont">
                                <ContactInfo icon="phone_icon.png" label="Enquiry" value="+01 2242 3366" />
                                <ContactInfo icon="mail_icon.png" label="Get Support" value="info@example.com" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Stats Counter Section - Restored original AOS and structure */}
            <section className="ab-cont">
                <div className="container">
                    <div className="row">
                        <ScrollTrigger>
                            <ul className="list-unstyled">
                                <StatItem icon="fa-heart" count={2000} label="Couples pared" duration="500" />
                                <StatItem icon="fa-users" count={4000} label="Registerents" duration="700" plus />
                                <StatItem icon="fa-male" count={1600} label="Mens" duration="900" plus />
                                <StatItem icon="fa-female" count={2000} label="Womens" duration="1100" plus />
                            </ul>
                        </ScrollTrigger>
                    </div>
                </div>
            </section>

            {/* Suchi Section - Restored l_img wrapper and full text */}
            <section className="pb-0">
                <div className="container suchi_section">
                    <div className="row">
                        <div className="col-md-4 ps-0">
                            <div className="l_img">
                                <img src="assets/imgs/suchi_img.png" alt="Suchi" />
                            </div>
                        </div>
                        <div className="col-md-8">
                            <div className="r_content">
                                <div className="section-heading">
                                    <h1 className="headingtxt">VMM Suchi <br /> Discover Your Perfect Match</h1>
                                </div>
                                <div className="txt-content">
                                    <p>
                                        Find your perfect life partner with VMM Suchi, the ultimate matrimonial solution! Our exclusive book, "VMM Suchi," is your gateway to a blissful and fulfilling married life. Dive into a treasure trove of carefully curated matrimonial profiles featuring eligible girls and boys from diverse backgrounds. Let destiny unfold as you explore detailed profiles, ensuring compatibility and shared values. Take the first step towards a lifetime of companionship and love with VMM Suchi – where your journey to finding a suitable life partner begins!
                                    </p>
                                </div>
                                {!isLoggedIn && (
                                    <button className="btn red_btn mt-4" data-bs-toggle="modal" data-bs-target="#registrationModal">
                                        Register Now
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Our Stories Section - Identical HTML Structure */}
            <section className="pb-0">
                <div className="container">
                    <div className="row">
                        <div className="home-tit" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="500">
                            <p>trusted brand</p>
                            <h2><span>Trust by <b className="num">1500</b>+ Couples</span></h2>
                            <span className="leaf1"></span>
                            <span className="tit-ani-"></span>
                        </div>
                    </div>
                    <Slider className="ourStories_slider" {...settings.ourStoriesSlider}>
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div key={i} className="hom-coup-box">
                                <span className="leaf"></span>
                                <img src="assets/imgs/stry.png" alt="Story" loading="lazy" />
                                <div className="bx">
                                    <h4>Dany & July <span>New York</span></h4>
                                    <button className="banner_btn btn" onClick={() => navigate("/wedding-video")}>View more</button>
                                </div>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>

            {/* Testimonials Section - Identical HTML Structure */}
            <section>
                <div className="container">
                    <div className="row">
                        <div className="home-tit" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="500">
                            <p>trusted brand</p>
                            <h2><span>Trust by <b className="num">1500</b>+ Couples</span></h2>
                            <span className="leaf1"></span>
                            <span className="tit-ani-"></span>
                        </div>
                    </div>
                    <Slider className="hom-cus-revi" {...settings.testimonialSlider}>
                        {[1, 2, 3, 4, 5].map((i) => (
                            <div key={i} className="cus-revi-box">
                                <div className="revi-im">
                                    <img src="assets/imgs/test.png" alt="Testimonial" loading="lazy" />
                                    <i className="cir-com cir-1"></i><i className="cir-com cir-2"></i><i className="cir-com cir-3"></i>
                                </div>
                                <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                                <h5>Jack danial</h5>
                                <span>New york</span>
                            </div>
                        ))}
                    </Slider>
                </div>
            </section>

            {/* Team Section - Restored social-light list and structure */}
            <section className="pt-0">
                <div className="container">
                    <div className="row">
                        <div className="home-tit" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration="500">
                            <p>OUR PROFESSIONALS</p>
                            <h2><span>Meet Our Team</span></h2>
                            <span className="leaf1"></span>
                            <span className="tit-ani-"></span>
                        </div>
                    </div>
                    <div className="row">
                        {[1, 2, 3, 4].map((i) => (
                            <div key={i} className="col-md-3">
                                <div className="ab-team">
                                    <img src="assets/imgs/our_team_mem.png" alt="Team" loading="lazy" />
                                    <h4>Julia sear</h4>
                                    <p>Client Coordinator</p>
                                    <ul className="social-light">
                                        <li><i className="fa fa-heart" aria-hidden="true"></i></li>
                                        <li><i className="fa fa-heart" aria-hidden="true"></i></li>
                                        <li><i className="fa fa-heart" aria-hidden="true"></i></li>
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Footer Banner - Restored original text and buttons */}
            <section className="pt-0">
                <div className="container">
                    <div className="row">
                        <div className="fot-ban-inn">
                            <div className="lhs">
                                <h2>Find your perfect Match now</h2>
                                <p>lacinia viverra lectus. Fusce imperdiet ullamcorper metus eu fringilla. Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                {!isLoggedIn && (
                                    <button className="btn" data-bs-toggle="modal" data-bs-target="#registrationModal">
                                        Register Now
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

// Internal Sub-components to keep the main return clean but identical in output
const ContactInfo = ({ icon, label, value }) => (
    <div className="cont_d me-4">
        <img className="icon_img" src={`assets/imgs/${icon}`} alt={label} />
        <div className="cont_info">
            <p>{label}</p>
            <h5>{value}</h5>
        </div>
    </div>
);

const StatItem = ({ icon, count, label, duration, plus = false }) => (
    <li data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-duration={duration}>
        <div className="ab-cont-po">
            <i className={`fa ${icon}`} aria-hidden="true"></i>
            <div>
                <h4><CountUp end={count} redraw={true} />{plus && "+"}</h4>
                <span>{label}</span>
            </div>
        </div>
    </li>
);

export default Home;